import { LOCALSTORAGEFIELDS } from "./../constants/index";

export const updateFavicon = (system: "sr" | "sbs") => {
  let link = document.querySelector(
    "link[rel~='icon']"
  ) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  const timestamp = new Date().getTime();

  if (system === "sbs") {
    link.href = `/favicon_sbs.ico?v=${timestamp}`;
  } else {
    link.href = `/favicon.svg?v=${timestamp}`;
  }
};

export const getSystemCode = () => {
  try {
    const activeSystem = localStorage.getItem(LOCALSTORAGEFIELDS.activeSystem);
    return activeSystem || "sr";
  } catch (e) {
    return "sr";
  }
};
